export default "__VITE_ASSET__BZILOpco__"